import {useMemo} from 'react';
import {assert} from 'assert-ts';
import {useParams} from 'react-router';
import type {AgentSubType} from 'types';
import {useQueryParams} from 'navigation/hooks';
import type {AgentIdParam, NewAgentParam} from '../types';

export const useAgentUrlParameters = (): AgentIdParam | NewAgentParam => {
  const {agentId} = useParams();
  const queryParams = useQueryParams<{
    type: AgentSubType;
    suggestion: string;
  }>();

  return useMemo(() => {
    return agentId === 'new'
      ? {
          suggestion: queryParams.suggestion,
          agentType: assert(
            queryParams.type,
            'useAgentUrlParameters: agentType expected',
            {agentId, queryParams},
          ),
        }
      : {
          agentId: assert(agentId, 'useAgentUrlParameters: agentId expected', {
            agentId,
            queryParams,
          }),
        };
  }, [agentId, queryParams]);
};
